import styled from "styled-components"
import Fieldset from "components/_UI/Fieldset"
import breakpoints from "theme/breakpoints"
import debounce from "helpers/debounce"

export default function EstablishmentOrderFilters({
    onUpdateFilter = () => {}
}) {
    const onTextSearchChange = debounce((text) => {
        onUpdateFilter({
            search: text,
        });
    }, 500);
    
    return (
        <>
            <Container>
                <FiltersRow>
                    <SearchContainer>
                        <Fieldset
                            placeholder="Buscar por nome"
                            layout='squired'
                            style={{ paddingRight: "2rem", marginTop: "0" }}
                            onChangeValue={onTextSearchChange}
                        />
                    </SearchContainer>
                </FiltersRow>
            </Container>
        </>
    );
}


const Container = styled.div`
  width: 100%;
`

const FiltersRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
  width: 100%;
  
  @media screen and (min-width: ${breakpoints.md}) {
    flex-direction: row;
  }
`

const SearchContainer = styled.div`
  flex: 1;
  width: 100%;
`